// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2w3BP","header":"Messages_header__3UAtL"};